/**
 * TrialCreditNote — the one sentence about the trial dollar, used on every
 * trial surface so the rule is worded identically everywhere (Randy, Oct 2026):
 * whatever is left of it ENDS when the trial ends or converts.
 *
 * Never hardcodes the figure — reads `credit.grant_cents` / `remaining_cents`
 * from /api/trial/status (TRIAL_PLAN.md §8.11).
 */
import { Info } from "@phosphor-icons/react";
import { money } from "@/lib/trial";

const TONES = {
  light: "bg-[#E8EBE5] text-[#4A5D4E] border-[#4A5D4E]/20",
  dark: "bg-white/[0.07] text-[#CBDDF0] border-white/15",
  plain: "bg-transparent text-[#4A5D4E] border-transparent px-0 py-0",
};

export default function TrialCreditNote({ trial, tone = "light", testId = "trial-credit-note" }) {
  const c = trial?.credit || {};
  const granted = !!c.granted_at;
  const remaining = Number(c.remaining_cents || 0);
  const voided = !!c.voided_at;

  let text;
  if (!granted) {
    text = `We'll cover the first 50 or so queries you test against your twin. After that you can top up. My-Silo is “SO” efficient, a few dollars could last you weeks.`;
  } else if (voided) {
    text = `Your trial credit has ended${c.void_reason === "byok_activated" ? " — you're on your own key now" : ""}. Anything you bought yourself is untouched.`;
  } else if (remaining > 0) {
    text = `${money(remaining)} of trial credit left. It's billed at cost (1×) and expires when your trial ends or converts — it is never refunded or cashed out.`;
  } else {
    text = `Your ${money(c.cents)} of trial credit is spent. Top up or bring your own Gemini key to keep your twin answering.`;
  }

  return (
    <div
      className={`flex items-start gap-2 text-[11px] leading-relaxed rounded-md border px-2.5 py-2 ${TONES[tone] || TONES.light}`}
      data-testid={testId}
    >
      <Info size={13} weight="duotone" className="mt-[1px] shrink-0" />
      <span>{text}</span>
    </div>
  );
}
